/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type CohortFilterGroupKind = (typeof CohortFilterGroupKind)[keyof typeof CohortFilterGroupKind];

export const CohortFilterGroupKind = {
  group: 'group',
} as const;
